/**
 * <s-countdown data-deadline="ISO-8601"> — ticks the [data-unit="days|hours|minutes|seconds"]
 * children once a second. When the deadline passes it hides the closest [data-countdown-host]
 * (or itself), so an expired promotion never lingers on the page.
 */
class SCountdown extends HTMLElement {
  #timer = 0;
  #deadline = 0;

  connectedCallback() {
    this.#deadline = Date.parse(this.dataset.deadline || '');
    if (Number.isNaN(this.#deadline)) return;
    this.#tick();
    this.#timer = window.setInterval(() => this.#tick(), 1000);
  }

  disconnectedCallback() {
    window.clearInterval(this.#timer);
  }

  #tick() {
    const remaining = this.#deadline - Date.now();
    if (remaining <= 0) {
      window.clearInterval(this.#timer);
      const host = this.closest('[data-countdown-host]') || this;
      host.hidden = true;
      return;
    }
    const totalSeconds = Math.floor(remaining / 1000);
    const values = {
      days: Math.floor(totalSeconds / 86400),
      hours: Math.floor((totalSeconds % 86400) / 3600),
      minutes: Math.floor((totalSeconds % 3600) / 60),
      seconds: totalSeconds % 60,
    };
    for (const [unit, value] of Object.entries(values)) {
      const node = this.querySelector(`[data-unit="${unit}"]`);
      if (node) node.textContent = String(value).padStart(2, '0');
    }
  }
}

if (!customElements.get('s-countdown')) customElements.define('s-countdown', SCountdown);
